import { useNavigate } from "react-router";
import SetupEmail from "../components/email-setup";
import { useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";

const EmailSetup = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);
  const { isEmailSetupView } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/signin");
    }
    if (!isEmailSetupView) {
      navigate("/dashboard-view");
    }
  }, [isEmailSetupView, navigate, isAuthenticated]);

  return <SetupEmail />;
};

export default EmailSetup;
